module.exports = __webpack_public_path__ + "static/img/produto_p.f095321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_limao/produto_p.png
// module id = W2vt
// module chunks = 0